import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Device } from '../../model/device';
import { GenericAkitaHTTPService, HttpOptions } from '../../service/generic-akita-http.service';
import { NetworkService } from '../../service/network.service';


@Injectable({
  providedIn: 'root'
})
export class AkitaDeviceHttpService extends GenericAkitaHTTPService<Device> {
  constructor(http: HttpClient, networkService: NetworkService) {

    const options: HttpOptions = {
      params: {
        type: 'Device',
        options: 'keyValues',
        limit: '30'
      }
    };

    super(http, networkService, '/v2/entities/', 'device', options);
  }
}
